import React, { useEffect, useState } from 'react';
import {
  IonCardHeader,
  IonCardContent,
  IonRow,
  IonCol,
  IonButton,
  IonGrid,
  IonTextarea,
  IonIcon
} from '@ionic/react';
import CardContent from './cardContent';
import { FormatText } from './FormatTextComponent/formatText';
import getType from '../../../pages/Menu/GetDataType';
import { CustomModalWeb } from '../userProfile/CustomModalWeb';
import * as Constants from '../../../utils/constants';
// import StarRatingComponent from 'react-star-rating-component';
import { Rating } from 'react-simple-star-rating';
import { Feedback } from '../../../models/home/Menu.model';
import './Accordion.scss';
interface FAQAccordionProps {
  contextData: any;
  dataType: any;
  accordProps:any;
}
export const Accordion: React.FC<FAQAccordionProps> = ({
  contextData,
  dataType,
  accordProps
}) => {
const [isShowContent, setIsShowContent] = useState<boolean>(false);
const [rating,setRating] =useState(0);
const [isShowModal,setisShowModal] =useState(false);
const [feedback,setFeedback] =useState("");
const [isShowPopup,setIsShowPopup] =useState(false);
  let valueDataType = 'text';
  const onCardHeaderClick = () => {
    setIsShowContent(!isShowContent);
  };
  const getDataType = (fieldName: string) => {
    if (dataType && dataType.length) {
      valueDataType = getType(dataType, fieldName);
    } else {
      valueDataType = 'text';
    }
    return valueDataType;
  };
  useEffect(() => {
    setIsShowContent(false);
  }, [contextData])
  const  handleOkClick = () => {
    setisShowModal(false);
    setRating(0);
    setFeedback("");
  };
 const  feedbackHandler = (event: any) => {
    if (event.target.name === 'feedback') {
      setFeedback(event.target.value);
    }
  };
  const onStarClick = (nextValue: any) => {
    setRating(nextValue);
  }
  const getVersion = (browserDetails: any, val: any) => browserDetails.split(val)[1].split(' ')[0];


  const  onSubmitFeedbackClick =  () => {
    const browserDetails = navigator.userAgent;
    const browser: any = Constants.BROWSER_DATA.find(item => browserDetails.indexOf(item.value) !== -1);
    const browserName = browser.name || '';
    const browserVersion = getVersion(browserDetails, browser.value) || '';
    const model: Feedback = new Feedback();
    model.appVersion = '';
    model.upn =  accordProps?.userDetails?.memberDetailsResponse?.member?.upn;
    model.deviceUUID = '';
    model.carrierId = accordProps?.userDetails?.memberDetailsResponse?.member?.carrierId;
    model.carrierName = accordProps?.userDetails?.memberDetailsResponse?.member?.companyName;
    model.rating = rating;
    model.feedback = feedback;
    model.firstName = accordProps?.userDetails?.memberDetailsResponse?.member?.firstName;
    model.lastName = accordProps?.userDetails?.memberDetailsResponse?.member?.lastName;
    model.devicePlatform = 'Web';
    model.deviceManufacturer = browserName;
    model.deviceOSVersion = '';
    model.deviceModel = browserVersion;
    accordProps && accordProps.submitFeedback(model.getRequestPayload(), feedBackCallback);
  };
    
  const feedBackCallback = () => {
    if (
      accordProps?.submitFeedbackCall?.data?.feedback === true
      && isShowPopup
    ) {

      setisShowModal(false);
      setRating(0);
    } else {
      setisShowModal(true);
    }
  };
  const feedbackModalProps = {
    title: Constants.FEEDBACK_HEADER,
    message_content: Constants.FEEDBACK_MESSAGE,
    size: "small_height",
    buttons: [
      {
        title: ("Ok"),
        type: "primary-cta-btn-web",
        onClick: () =>handleOkClick()
      }
    ]
  };
  return (
    <>
      {contextData.title.includes('Feedback for the App') ? null : (
        <>
          <IonCardHeader
            data-testid="IonCardHeader-Menu"
            class="accordion_header"
            onClick={onCardHeaderClick}
          >
            <IonRow>
              <IonCol className="title-col" size="10">
                <FormatText
                  text={contextData.title}
                  dataType={getDataType('title')}
                />
              </IonCol>
              <IonCol size="2">
                {isShowContent ? (
                  <i className="Down_arrow" />
                ) : (
                  <i className="Up_arrow" />
                )}
              </IonCol>
            </IonRow>
          </IonCardHeader>
          {isShowContent &&
            <IonCardContent className={isShowContent ? 'fadeout' : 'fadein'} data-testid="card-content">
              {contextData && contextData.richTextDescription ? (
                <div className="description-div">
                  <FormatText
                    text={contextData.richTextDescription}
                    dataType={getDataType('richTextDescription')}
                  />
                  {contextData.title.includes('Feedback') ? (
                  <div className="feedbackDiv" data-test="Feedback-div">
          <CustomModalWeb isModalOpen={isShowModal} {...feedbackModalProps} />
            <IonGrid className="feedback-grid">
              <p className="feedback-p notLikely">{Constants.NOT_LIKELY}</p>
              <p className="feedback-p likely">{Constants.VERY_LIKELY}</p>
              <IonRow className="feedback-row">
                <IonCol className="feedback-column">
                  {/* <StarRatingComponent
                    name="rate1"
                    starCount={5}
                    value={rating}
                    onStarClick={onStarClick}
                    starColor="#FF6114"
                    className="starRating"
                    renderStarIcon={(index: any, value: any) => (
                      <IonIcon
                        className="starRatingIcon"
                        src={
                          index <= value
                            ? 'assets/icon/feedback-star-filled.svg'
                            : 'assets/icon/feedback-star.svg'
                        }
                      />
                    )}
                  /> */}
                   <Rating
                    fillColor="#f85f14"
                    className="starRating"
                    initialValue={rating}
                    onClick={onStarClick}
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
            {rating === 0 ? null : (
              <>
                <IonGrid>
                  {rating <= 3 && rating >= 1 ? (
                    <div className="head-text">{Constants.IMPROVING_SERVICE}</div>
                  ) : (
                    <div className="head-text">{Constants.MORE_FEEDBACK}</div>
                  )}
                  <IonGrid className="text-div">
                    <IonTextarea
                      maxlength={2000}
                      placeholder={Constants.FEEDBACK_COMMENTS}
                      onIonChange={e => feedbackHandler(e)}
                      name="feedback"
                      value={feedback}
                    />
                  </IonGrid>
                  <IonRow class="ion-text-right">
                    <IonCol>{feedback.length}/2000</IonCol>
                  </IonRow>
                </IonGrid>
              </>
            )}
            <IonRow class="ion-text-right">
              <IonCol>
                <IonButton
                  data-test="submit-button"
                  data-kind="primary"
                  type="submit"
                  disabled={rating === 0}
                  class="primary-cta-btn-web"
                  onClick={() => onSubmitFeedbackClick()}>
                  {Constants.SUBMIT}
                </IonButton>
              </IonCol>
            </IonRow>
          </div>
          ) : null}
                </div>
              ) : (
                contextData &&
                contextData.group &&
                contextData.group.map((groupData: any, index: number) => (
                  <CardContent
                    key={index}
                    groupData={groupData}
                    dataType={getDataType('group')}
                  />
                ))
              )}
            </IonCardContent>
          }
        </>)
      }</>
  );
};